import { SubscriptionStatus } from './SubscriptionsDto'

export const isTransactionStatusInProcess = (value: number): boolean => {
  return value === SubscriptionStatus.IN_PROCESS
}
